import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import {
  buildSingleSportEventKey,
  SingleSportEventQueryOptions,
} from "./singleSportEventKey";
import { getSportEventNew } from "@/api/sportEventsNew";

import { getRefetchIntervalByFeedType } from "@/utils/sportEvents";

interface Options {
  queryOptions: SingleSportEventQueryOptions;
}

export const useSportEventNew = (options: Options) => {
  const locale = useLocale();
 
  return useQuery({
    queryKey: buildSingleSportEventKey(locale, options.queryOptions),
    enabled:  Boolean(options.queryOptions.id) && Boolean(options.queryOptions.providerId),
    refetchInterval: getRefetchIntervalByFeedType(options.queryOptions.feedType),
    queryFn: async ({ signal }) => {
      const params = { lang: locale, ...options.queryOptions };
      return  await getSportEventNew({ signal, params });
    },
  });
};
